<template lang="pug">
  SingleLayout(
    :item='true'
    :itemlist='true'
  )
    template(
      slot='item'
      v-if='personal'
    )
      Artist(
        type='full'
        :artist='personal'
        :key='personalId'
        :editable='true'
      )

    template(slot='itemlist')
      ItemList(
        type='albums'
        :title='$l10n("MY_MUSIC")'
        :items='items'
        :editable='true'
        :review='true'
        :links='links'
        :params='{ target }'
        :key='personalId'
        :creator='creator'
        :empty-message='isSingles ? $l10n("ARTIST_DONT_HAVE_TRACKS") : $l10n("ARTIST_DONT_HAVE_ALBUMS")'
        :tracklist='isSingles ? tracklist : null'
      )
</template>

<script>
import singlePage from "@/mixins/pages/single.mixin";
import PageLoader from "@/services/pageLoader";
import ItemList from "@/components/ItemList/ItemList";
import Artist from "@/components/Artist/Artist";
import errorHandler from "@/services/errorHandler";

import { mapGetters } from "vuex";

const strategy = async function(route, ctx) {
  try {
    const { artist = {} } = await PageLoader.getPersonalInfo();

    ctx.target = route.query.target || "albums";
    route.meta.title = artist.title;
  } catch (error) {
    errorHandler.resolve(error);
  }

  try {
    const { singles } = await PageLoader.getPersonalSingles();
    const singlesIds = singles.map(album => album.id);

    ctx.personalSinglesIds = singlesIds;
  } catch (error) {
    errorHandler.add(error);
  }

  try {
    const { albums } = await PageLoader.getPersonalAlbums();
    const albumsIds = albums.map(album => album.id);

    ctx.personalAlbumsIds = albumsIds;
  } catch (error) {
    errorHandler.add(error);
  }
};

export default {
  name: "PersonalPage",
  mixins: [singlePage(strategy)],
  data() {
    return {
      personalSinglesIds: [],
      personalAlbumsIds: [],
      target: ""
    };
  },
  computed: {
    ...mapGetters({
      personal: "personal/info",
      albums: "albums/albums"
    }),
    personalId() {
      return this.personal.id;
    },
    personalAlbums() {
      return this.personalAlbumsIds.reduce((albums, id) => {
        return this.albums[id] ? [...albums, this.albums[id]] : albums;
      }, []);
    },
    personalSingles() {
      return this.personalSinglesIds.reduce((singles, id) => {
        return this.albums[id] ? [...singles, this.albums[id]] : singles;
      }, []);
    },
    items() {
      return this.isSingles ? this.personalSingles : this.personalAlbums;
    },
    isSingles() {
      return this.target === "singles";
    },
    creator() {
      return {
        label: this.isSingles
          ? this.$l10n("NEW_SINGLE")
          : this.$l10n("NEW_ALBUM"),
        href: this.isSingles ? "/albums/create?type=singles" : "/albums/create"
      };
    },
    links() {
      return [
        {
          type: "albums",
          label: this.$l10n("ALBUMS"),
          path: this.$route.path,
          query: { ...this.$route.query, target: "albums" }
        },
        {
          type: "singles",
          label: this.$l10n("SINGLES"),
          path: this.$route.path,
          query: { ...this.$route.query, target: "singles" }
        }
      ];
    },
    tracklist() {
      return {
        id: this.personalId,
        tracks: this.personalSinglesIds
      };
    }
  },
  components: {
    Artist,
    ItemList
  }
};
</script>
